import type dayjs from 'dayjs';

interface Params {
    date: dayjs.Dayjs;
    blockHeight: string;
}

const DATE_FORMAT = 'YYYYMMDDTHHmmss';

export default function createIcsFileBlob({date, blockHeight}: Params): Blob {
    const name = `Block #${blockHeight} reminder | ${process.env.REACT_APP_BASE_UNIT}`;
    const description = `#${blockHeight} block creation time on ${process.env.REACT_APP_BASE_UNIT} blockchain.`;
    const startTime = date.format(DATE_FORMAT);
    const endTime = date.add(15, 'minutes').format(DATE_FORMAT);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const blockUrl = `${process.env.REACT_APP_BASEURL}/block/${blockHeight}`;

    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${name}
DESCRIPTION:${description}
DTSTART;TZID=${timeZone}:${startTime}
DTEND;TZID=${timeZone}:${endTime}
URL:${blockUrl}
END:VEVENT
END:VCALENDAR`;

    return new Blob([icsContent], {type: 'text/calendar'});
}
